import { bootstrapApplication } from '@angular/platform-browser';
import { StatusBar, Style } from '@capacitor/status-bar';
import {Capacitor} from "@capacitor/core";
import { provideServiceWorker } from '@angular/service-worker';
import { isDevMode, provideZoneChangeDetection } from '@angular/core';
import { startEmbeddedPhotoViewer } from '@app/helpers/review-photo-viewer.helper';

const isNative = Capacitor.isNativePlatform(); // true on iOS/Android

async function configureStatusBar(): Promise<void> {
    if (!isNative || !Capacitor.isPluginAvailable('StatusBar')) {
        return;
    }

    try {
        await StatusBar.show();
        await StatusBar.setOverlaysWebView({ overlay: true });
        await StatusBar.setBackgroundColor({ color: '#ffffff' });
        await StatusBar.setStyle({ style: Style.Light });
    } catch (error) {
        console.error('Failed to configure status bar:', error);
    }
}

async function startApplication(): Promise<void> {
    if (await startEmbeddedPhotoViewer()) {
        return;
    }

    const [{ appConfig }, { App }] = await Promise.all([
        import('@app/app.config'),
        import('@app/app'),
    ]);
    await configureStatusBar();

    bootstrapApplication(App, {
        ...appConfig,
        providers: [
            provideZoneChangeDetection(),...(appConfig.providers ?? []),
            provideServiceWorker('ngsw-worker.js', {
                enabled: !isNative,
                registrationStrategy: 'registerWhenStable:30000',
            }),
            provideServiceWorker('ngsw-worker.js', {
                enabled: !isDevMode(),
                registrationStrategy: 'registerWhenStable:30000',
            }),
        ],
    }).catch((error) => console.error(error));
}

void startApplication();
